/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './listNotifications.defs.js'
export { main as default } from './listNotifications.defs.js'
